import { useState } from 'react'
import type { SolicitudCambioListItem } from '../services/jefeCocina'
import CountdownTimer from './CountdownTimer'

interface F11CardProps {
  solicitud: SolicitudCambioListItem
  slaMinutos: number
  onAprobar: (s: SolicitudCambioListItem) => void
  onRechazar: (s: SolicitudCambioListItem) => void
}

const MOTIVO_MAX = 200

export default function F11Card({
  solicitud,
  slaMinutos,
  onAprobar,
  onRechazar,
}: F11CardProps) {
  const [verMas, setVerMas] = useState(false)
  const motivoTruncado = solicitud.motivo_enfermera.length > MOTIVO_MAX
  const motivoMostrado = verMas || !motivoTruncado
    ? solicitud.motivo_enfermera
    : solicitud.motivo_enfermera.slice(0, MOTIVO_MAX) + '…'

  return (
    <article
      aria-labelledby={`f11-card-title-${solicitud.id}`}
      className="bg-white dark:bg-gray-800 rounded-lg shadow-md border-l-4 border-avante-warning p-4 flex flex-col gap-2"
    >
      <header className="flex justify-between items-start gap-2">
        <div>
          <h3
            id={`f11-card-title-${solicitud.id}`}
            className="font-bold text-base text-gray-900 dark:text-gray-50"
          >
            Hab. {solicitud.habitacion} — {solicitud.paciente_nombre}
          </h3>
          <p className="text-sm text-gray-700 dark:text-gray-300">
            <span className="font-semibold">{solicitud.dieta_original_nombre}</span>
            {' → '}
            <span className="font-semibold text-avante-accent">
              {solicitud.dieta_nueva_nombre}
            </span>
          </p>
        </div>
        <CountdownTimer
          startedAt={solicitud.solicitado_at}
          slaMinutes={slaMinutos}
        />
      </header>

      <div className="text-sm text-gray-700 dark:text-gray-300">
        <p>
          <span className="font-semibold">Motivo enfermera:</span> {motivoMostrado}
        </p>
        {motivoTruncado && (
          <button
            type="button"
            onClick={() => setVerMas((v) => !v)}
            className="text-avante-primary dark:text-avante-accent text-xs underline mt-1"
          >
            {verMas ? 'ver menos' : 'ver más'}
          </button>
        )}
      </div>

      {(solicitud.escalada_chef_corp || solicitud.escalada_admin) && (
        <p className="text-xs italic text-amber-700 dark:text-amber-300">
          {solicitud.escalada_chef_corp && 'Escalada a chef corporativo. '}
          {solicitud.escalada_admin && 'Escalada a admin.'}
        </p>
      )}

      <footer className="flex gap-2 pt-2 border-t border-gray-100 dark:border-gray-700">
        <button
          type="button"
          onClick={() => onAprobar(solicitud)}
          className="bg-avante-success text-white px-3 py-1.5 rounded text-sm font-semibold hover:bg-green-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-avante-success"
        >
          Aprobar
        </button>
        <button
          type="button"
          onClick={() => onRechazar(solicitud)}
          className="bg-avante-danger text-white px-3 py-1.5 rounded text-sm font-semibold hover:bg-red-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-avante-danger"
        >
          Rechazar
        </button>
      </footer>
    </article>
  )
}
